import { useMemo } from "react";

import { FormInstance } from "antd/es/form/hooks/useForm";
import { defineMessages, IntlShape } from "react-intl";

import { isNotEmptyString } from "@mapmycustomers/shared/util/assert";

const messages = defineMessages({
  city: {
    id: "validation.address.field.city",
    defaultMessage: "City",
    description: "City address field",
  },
  country: {
    id: "validation.address.field.country",
    defaultMessage: "Country",
    description: "County address field",
  },
  missingFields: {
    id: "validation.address.missingFields",
    defaultMessage: "Please enter: {fields}",
    description: "Validation message for missing address fields",
  },
  postalCode: {
    id: "validation.address.field.postalCode",
    defaultMessage: "Postal Code",
    description: "Postal Code address field",
  },
  region: {
    id: "validation.address.field.region",
    defaultMessage: "State/Province",
    description: "State address field",
  },
  street: {
    id: "validation.address.field.street",
    defaultMessage: "Street",
    description: "Street address field",
  },
});

export const useAddressFieldValidationRules = (intl: IntlShape, form: FormInstance) =>
  useMemo(
    () => [
      {
        validator: () => {
          const addressDetails = form.getFieldValue("addressDetails");

          const requiredFields = [
            {
              key: "address",
              label: intl.formatMessage(messages.street),
            },
            {
              key: "city",
              label: intl.formatMessage(messages.city),
            },
            {
              key: "postalCode",
              label: intl.formatMessage(messages.postalCode),
            },
            {
              key: "country",
              label: intl.formatMessage(messages.country),
            },
            {
              key: "region",
              label: intl.formatMessage(messages.region),
            },
          ];

          const missingFields = requiredFields
            .filter(({ key }) => !isNotEmptyString(addressDetails?.[key]?.trim()))
            .map(({ label }) => label);

          if (missingFields.length === 0) {
            return Promise.resolve();
          }

          return Promise.reject(
            intl.formatMessage(messages.missingFields, { fields: missingFields.join(", ") })
          );
        },
      },
    ],
    [intl, form]
  );
